import type { IDiagnosis } from '@frontend/components/interfaces';
import type { IDiagnosticReportAddEdit } from '@frontend/components/pages/diagnosticReports/DiagnosticReportItemAddEdit';
import { saveTypeEnum } from '@common/enums';

export function prepareDiagnosticReportForSave(
    diagnosticReport: IDiagnosticReportAddEdit | null,
    saveType: saveTypeEnum
) {
    return diagnosticReport
        ? {
              ...diagnosticReport,
              diagnosis: prepareDiagnosisForSave(diagnosticReport.diagnosis, saveType),
          }
        : null;
}

export function prepareDiagnosisForSave(diagnosis: IDiagnosis, saveType: saveTypeEnum) {
    if (saveType === saveTypeEnum.final || !diagnosis.considerationThesaurusTermId) {
        const { diagnosisConsiderationIcd10fallback, ...restDiagnosis } = diagnosis;

        return {
            ...restDiagnosis,
            diagnosisConsiderationIcd10: diagnosis.diagnosisConsiderationIcd10
                ? diagnosis.diagnosisConsiderationIcd10
                : diagnosis.diagnosisConsiderationIcd10fallback || null,
        };
    }

    return diagnosis;
}
